var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87656 15.999C5.79948 15.967 3.81432 15.128 2.34314 13.6569C0.842854 12.1566 -1.85488e-07 10.1217 0 8C3.86258e-07 3.58172 3.58172 -3.86258e-07 8 0C12.3769 3.82637e-07 15.9328 3.51488 15.9991 7.87596C15.9324 12.3321 12.3326 15.932 7.87656 15.999ZM7.99995 4C7.55813 4 7.19995 4.35817 7.19995 4.79999L7.19995 8.79999C7.19995 9.24182 7.55812 9.59999 7.99995 9.59999C8.44178 9.59999 8.79995 9.24182 8.79995 8.8V4.79999C8.79995 4.35817 8.44178 4 7.99995 4ZM7.99995 10.4C8.44178 10.4 8.79995 10.7582 8.79995 11.2C8.79995 11.6418 8.44178 12 7.99995 12C7.55812 12 7.19995 11.6418 7.19995 11.2C7.19995 10.7582 7.55812 10.4 7.99995 10.4Z",
    fill: "#D30813"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFail);
export default __webpack_public_path__ + "static/media/status-fail.43d9ca3d708d6d8ac61f2d2030df960e.svg";
export { ForwardRef as ReactComponent };